export default __webpack_public_path__ + "static/Angie-5b269e57f703617a1a47d9db2a9d27be0287553ba299cb2f9c6972d989890df2.svg";